import type { IconSvgObject } from './types';

const TropicalStormTracks02Icon: IconSvgObject = [
  ["path", { d: "M17 9.5L19.5 7M19.5 7L22 9.5M19.5 7V13C19.5 16.866 16.366 20 12.5 20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8.5 12.5C9.60457 12.5 10.5 11.6046 10.5 10.5C10.5 9.39543 9.60457 8.5 8.5 8.5C7.39543 8.5 6.5 9.39543 6.5 10.5C6.5 11.6046 7.39543 12.5 8.5 12.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M15 4.37853L12 6C13.2261 7.04798 14 8.75613 14 10.5C14 16.4563 6.58139 17.7721 2 16.6215L5 15C3.77392 13.952 3 12.2439 3 10.5C3 4.54371 10.4186 3.22793 15 4.37853Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default TropicalStormTracks02Icon;
